var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"json-editor-container"},[_c('JsonEditor',{attrs:{"options":_vm.options,"objData":_vm.modelVal},model:{value:(_vm.modelVal),callback:function ($$v) {_vm.modelVal=$$v},expression:"modelVal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }